"use strict";

import "./nucont.core.module";
import "./configs/navigation.config";
import "./app.component";
import appConfig from "./lib/app.config";
import appRun from "./lib/app.run";

import angular from "angular";

angular.module("nucont").run(appRun).config(appConfig);
